<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id' :disabled='option.id == 2 && remote_sensing'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ACT_INFO = 'get_act_info.php'
	const LPO_MODE = 'get_lpo_mode.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'lpoMode',
		data: function () { 
			return {
				selected: '',
				options: [],
				remote_sensing: false
			}
		},
		props: {
			method: null
		},
		methods: {
			change () {
				EventBus.$emit(`edit_lpo_mode`, this.selected)
			},
			getOptions(method_id) {
				fetch(DB + ACT_INFO + '?id=' + this.$route.params.id, {
					credentials: 'include'
				})
				.then(res => res.json())
				.then(res => {
					return res[0].f_90
				})
				.then(id => {
					fetch(DB + LPO_MODE + '?id=' + method_id, {
						credentials: 'include'
					})
					.then(data => data.json())
					.then(data => {
						if (data) {
							this.options = data
							this.selected = id ? id : data[0].id
						}
						else {
							this.options = []
						}
					})
					.catch(err => console.log(err))
				})
				.catch(err => console.log(err))
			}
		},
		created: function () {
			if(this.method) {
				this.getOptions(this.method)
			} else {
				EventBus.$on('edit_lpo_method', id => {
					this.getOptions(id)
				})
			}

			/*EventBus.$on('edit_lpo_method', id => {
				if(id == 1)
				{
					if(this.selected == 2)
					{
						this.selected = 1
						this.change()
					}
					this.remote_sensing = true
				}
				else
					this.remote_sensing = false
			})*/
		},
		beforeDestroy() {
			EventBus.$off('edit_lpo_method')
		}
	}
</script>


// WEBPACK FOOTER //
// lpoMode.vue?6d4427df